import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Reveal from "react-reveal/Reveal"
import { Link } from "gatsby"
import styles from "./main.module.scss"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const Main = () => {
  const data = useStaticQuery(
    graphql`
      query {
        sungharsh: file(relativePath: { eq: "Profilepic.JPG" }) {
          childImageSharp {
            fluid(maxWidth: 730) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  return (
    <main>
      <Row
        className={`mx-0 
      pt-xl-3 pt-lg-3 pt-md-3 
      bg-light px-md-3 ${styles.mainWrapper}`}
      >
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={8}
          xl={8}
          className={`border bg-light mx-auto px-0 mb-lg-3 mb-md-3 mb-xl-3 mb-md-3 ${styles.mainCol}`}
        >
          <Row className="mx-0 pb-3">
            <Col
              xs={12}
              sm={12}
              md={7}
              lg={8}
              xl={8}
              className="m-auto px-0 py-3"
            >
              <section className="col-12 m-auto mx-auto">
                <h1
                  className={`display-4 text-center textGradent ${styles.articalHeading}`}
                >
                  My Story
                </h1>
                <Reveal bottom>
                  <p>
                    Hi I am Sungharsh and I am a software developer. I enjoy
                    building applications. My career started as a Software
                    Engineer since 2015. I have a passion for coding and
                    building Apps for Web, IOS and Android.
                  </p>
                </Reveal>
                <p>
                  I am acquaint with the technologies like &nbsp;
                  <span className="text-monospace text-primary">
                    JavaScript, NodeJS, ReactJS, Reactnative, Angular.
                  </span>
                  &nbsp; I also have skills in various technologies, some of
                  them includes &nbsp;
                  <span className="text-monospace text-primary">
                    ES5, ES6, HTML5, CSS3, ReactJS, ViewJS, GatsbyJS, Material
                    UI, Bootstrap-4
                  </span>
                  &nbsp;and many others. I am very easily adaptable to new
                  technologies.
                </p>
              </section>
            </Col>
            <Col
              xs={12}
              sm={12}
              md={5}
              lg={4}
              xl={4}
              className="px-0 py-2 mx-0 m-auto"
            >
              <Img
                className="col-lg-11 col-md-12 d-block m-auto float-right img-fluid w-100"
                alt="profile picture"
                fluid={data.sungharsh.childImageSharp.fluid}
              />
            </Col>

            <Col className="m-auto mx-auto">
              <Reveal bottom>
                <p className="mb-0">
                  I regularly hurdle with Mernstack and Jamstack to boost my
                  skills set. I am exploring and experimenting in this horizon.
                  I have built this site using GatsbyJS to present some of my
                  skill set.
                </p>
                <br />
              </Reveal>
              <blockquote className="blockquote text-right mr-4">
                <p className="mb-0">
                  "I belive in accepting new challanges which in turn gives more
                  wisdom and prosparity in life."
                </p>
                <footer className="blockquote-footer text-primary text-monospace">
                  <cite title="in my own words">Sungharsh</cite>
                </footer>
              </blockquote>
              <hr className="mt-5 bg-info" />
              <Link
                to="/Blog"
                className={`float-right text-secondary`}
                type="button"
                role="button"
              >
                <abbr title="Read my Blog" className="customLink btnTrn">
                  Visit my blog
                </abbr>
                <span className="text-danger">
                  <strong> &#62;</strong>
                </span>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
    </main>
  )
}

export default Main
